export default __webpack_public_path__ + "static/media/snowSix.f72b3e62.jpg";